import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class CollarServiceMock {
  deletedCollars$ = of(undefined);
  getCollarLastreceptions() {
    return of([]);
  }
}
